import TableCellLink from "ds/components/Table/Row/CellLink";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { FlowsProjectRow } from "../types";

const FlowsProjectsListNameCell = ({
  item: project,
  ...cellProps
}: TableSimpleCellProps<FlowsProjectRow>) => (
  <TableSimpleCell {...cellProps} role="rowheader">
    <TableCellLink href={`/flows/${project.id}`}>{project.name}</TableCellLink>
  </TableSimpleCell>
);

export default FlowsProjectsListNameCell;
